module.exports = __webpack_public_path__ + "static/pingu-faf1073f5df33b03ec718df1190ede20.jpg";